import { useEffect, useState } from 'react'
import { copyDelay } from '../utils/constants'

export const useCopyToClipboard = () => {
  const [copied, setCopied] = useState<boolean>(false)
  const [timeOut] = useState<{
    value: ReturnType<typeof setTimeout> | undefined
  }>({
    value: undefined,
  })

  const copy = (text: string) => {
    navigator.clipboard.writeText(text)

    setCopied(true)
    timeOut.value = setTimeout(() => {
      clearTimeout(timeOut.value)
      setCopied(false)
    }, copyDelay)
  }

  useEffect(() => {
    return () => clearTimeout(timeOut.value)
  }, [])

  return { copied, copy }
}
